export enum MessageSelectionMode {
    forwarding = 'forwarding',
    reporting = 'reporting',
}
